export default __webpack_public_path__ + "static/media/logotype.154b41d8.jpg";